"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Smile: function() {
        return Smile;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Smile = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM7.84961 9.29961C7.84961 8.4988 8.4988 7.84961 9.29961 7.84961C10.1004 7.84961 10.7496 8.4988 10.7496 9.29961C10.7496 10.1004 10.1004 10.7496 9.29961 10.7496C8.4988 10.7496 7.84961 10.1004 7.84961 9.29961ZM13.25 9.29961C13.25 8.4988 13.8992 7.84961 14.7 7.84961C15.5008 7.84961 16.15 8.4988 16.15 9.29961C16.15 10.1004 15.5008 10.7496 14.7 10.7496C13.8992 10.7496 13.25 10.1004 13.25 9.29961ZM16.9843 13.0836C17.4904 13.3048 17.7214 13.8943 17.5003 14.4004C16.5753 16.5174 14.4619 18 12 18C9.53803 18 7.42462 16.5174 6.49966 14.4004C6.27854 13.8943 6.50956 13.3048 7.01564 13.0836C7.52173 12.8625 8.11125 13.0935 8.33237 13.5996C8.95053 15.0144 10.3613 16 12 16C13.6387 16 15.0494 15.0144 15.6676 13.5996C15.8887 13.0935 16.4782 12.8625 16.9843 13.0836Z",
        fill: "currentColor"
    })
}), "Smile");
const _default = Smile;
